import { createFileRoute } from '@tanstack/react-router';
import { ProgramsPage } from '@/components/ProgramsPage';

export const Route = createFileRoute('/_authenticated/programs/$')({
  component: ProgramsPage,
});
